// extracted by mini-css-extract-plugin
export var auth_logo = "index-module--auth_logo--d5efc";
export var effect_content_container = "index-module--effect_content_container--0e73e";
export var effect_privacy_container = "index-module--effect_privacy_container--8deb1";
export var effect_privacy_layout = "index-module--effect_privacy_layout--3629f";
export var privacy_link = "index-module--privacy_link--66ce5";
export var privacy_logos_container = "index-module--privacy_logos_container--de8e9";